import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@marsidev/react-turnstile/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/button/button.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/checkbox/checkbox.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/close-button/close-button.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/combobox/combobox.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/data-interactive/data-interactive.js");
;
import(/* webpackMode: "eager", webpackExports: ["Description"] */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/description/description.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/dialog/dialog.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/disclosure/disclosure.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/field/field.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/fieldset/fieldset.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/focus-trap/focus-trap.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/input/input.js");
;
import(/* webpackMode: "eager", webpackExports: ["Label"] */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/label/label.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/legend/legend.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/listbox/listbox.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/menu/menu.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/popover/popover.js");
;
import(/* webpackMode: "eager", webpackExports: ["Portal"] */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/portal/portal.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/radio-group/radio-group.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/select/select.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/switch/switch.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/tabs/tabs.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/textarea/textarea.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/transition/transition.js");
;
import(/* webpackMode: "eager", webpackExports: ["useClose"] */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/internal/close-provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/fonts/index.tsx\",\"import\":\"DM_Mono\",\"arguments\":[{\"fallback\":[\"Courier New\",\"monospace\"],\"weight\":[\"400\",\"500\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-mono\",\"preload\":false}],\"variableName\":\"Mono\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"app/fonts/index.tsx\",\"import\":\"\",\"arguments\":[{\"variable\":\"--font-sans\",\"display\":\"swap\",\"preload\":false,\"fallback\":[\"Inter\",\"Hedvig\",\"Helvetica Neue\",\"Arial\",\"sans-serif\"],\"src\":[{\"path\":\"./unica77.ttf\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"./Unica77LLWeb-Medium.woff\",\"weight\":\"600\",\"style\":\"normal\"},{\"path\":\"./unica77_bold.ttf\",\"weight\":\"800\",\"style\":\"normal\"}]}],\"variableName\":\"Unica77\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"app/fonts/index.tsx\",\"import\":\"\",\"arguments\":[{\"variable\":\"--font-ivyora\",\"display\":\"swap\",\"preload\":true,\"fallback\":[\"Georgia\",\"Times New Roman\",\"serif\"],\"weight\":\"100 900\",\"src\":[{\"path\":\"./IvyoraVariable.woff2\",\"style\":\"normal\"}]}],\"variableName\":\"IvyOra\"}");
;
import(/* webpackMode: "eager", webpackExports: ["WagmiContext","WagmiProvider"] */ "/vercel/path0/node_modules/wagmi/dist/esm/context.js");
;
import(/* webpackMode: "eager", webpackExports: ["useAccount"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useAccount.js");
;
import(/* webpackMode: "eager", webpackExports: ["useAccountEffect"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useAccountEffect.js");
;
import(/* webpackMode: "eager", webpackExports: ["useBalance"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useBalance.js");
;
import(/* webpackMode: "eager", webpackExports: ["useBlock"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useBlock.js");
;
import(/* webpackMode: "eager", webpackExports: ["useBlockNumber"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useBlockNumber.js");
;
import(/* webpackMode: "eager", webpackExports: ["useBlockTransactionCount"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useBlockTransactionCount.js");
;
import(/* webpackMode: "eager", webpackExports: ["useBytecode"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useBytecode.js");
;
import(/* webpackMode: "eager", webpackExports: ["useCall"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useCall.js");
;
import(/* webpackMode: "eager", webpackExports: ["useChainId"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useChainId.js");
;
import(/* webpackMode: "eager", webpackExports: ["useChains"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useChains.js");
;
import(/* webpackMode: "eager", webpackExports: ["useClient"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["useConfig"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useConfig.js");
;
import(/* webpackMode: "eager", webpackExports: ["useConnect"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useConnect.js");
;
import(/* webpackMode: "eager", webpackExports: ["useConnections"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useConnections.js");
;
import(/* webpackMode: "eager", webpackExports: ["useConnectorClient"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useConnectorClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["useConnectors"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useConnectors.js");
;
import(/* webpackMode: "eager", webpackExports: ["useDeployContract"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useDeployContract.js");
;
import(/* webpackMode: "eager", webpackExports: ["useDisconnect"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useDisconnect.js");
;
import(/* webpackMode: "eager", webpackExports: ["useEnsAddress"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useEnsAddress.js");
;
import(/* webpackMode: "eager", webpackExports: ["useEnsAvatar"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useEnsAvatar.js");
;
import(/* webpackMode: "eager", webpackExports: ["useEnsName"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useEnsName.js");
;
import(/* webpackMode: "eager", webpackExports: ["useEnsResolver"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useEnsResolver.js");
;
import(/* webpackMode: "eager", webpackExports: ["useEnsText"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useEnsText.js");
;
import(/* webpackMode: "eager", webpackExports: ["useEstimateFeesPerGas"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useEstimateFeesPerGas.js");
;
import(/* webpackMode: "eager", webpackExports: ["useEstimateGas"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useEstimateGas.js");
;
import(/* webpackMode: "eager", webpackExports: ["useEstimateMaxPriorityFeePerGas"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useEstimateMaxPriorityFeePerGas.js");
;
import(/* webpackMode: "eager", webpackExports: ["useFeeHistory"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useFeeHistory.js");
;
import(/* webpackMode: "eager", webpackExports: ["useGasPrice"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useGasPrice.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteReadContracts"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useInfiniteReadContracts.js");
;
import(/* webpackMode: "eager", webpackExports: ["usePrepareTransactionRequest"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/usePrepareTransactionRequest.js");
;
import(/* webpackMode: "eager", webpackExports: ["useProof"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useProof.js");
;
import(/* webpackMode: "eager", webpackExports: ["usePublicClient"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/usePublicClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["useReadContract"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useReadContract.js");
;
import(/* webpackMode: "eager", webpackExports: ["useReadContracts"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useReadContracts.js");
;
import(/* webpackMode: "eager", webpackExports: ["useReconnect"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useReconnect.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSendTransaction"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useSendTransaction.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSignMessage"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useSignMessage.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSignTypedData"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useSignTypedData.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSimulateContract"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useSimulateContract.js");
;
import(/* webpackMode: "eager", webpackExports: ["useStorageAt"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useStorageAt.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSwitchAccount"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useSwitchAccount.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSwitchChain"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useSwitchChain.js");
;
import(/* webpackMode: "eager", webpackExports: ["useToken"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useToken.js");
;
import(/* webpackMode: "eager", webpackExports: ["useTransaction"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useTransaction.js");
;
import(/* webpackMode: "eager", webpackExports: ["useTransactionConfirmations"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useTransactionConfirmations.js");
;
import(/* webpackMode: "eager", webpackExports: ["useTransactionCount"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useTransactionCount.js");
;
import(/* webpackMode: "eager", webpackExports: ["useTransactionReceipt"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useTransactionReceipt.js");
;
import(/* webpackMode: "eager", webpackExports: ["useVerifyMessage"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useVerifyMessage.js");
;
import(/* webpackMode: "eager", webpackExports: ["useVerifyTypedData"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useVerifyTypedData.js");
;
import(/* webpackMode: "eager", webpackExports: ["useWaitForTransactionReceipt"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useWaitForTransactionReceipt.js");
;
import(/* webpackMode: "eager", webpackExports: ["useWalletClient"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useWalletClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["useWatchAsset"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useWatchAsset.js");
;
import(/* webpackMode: "eager", webpackExports: ["useWatchBlockNumber"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useWatchBlockNumber.js");
;
import(/* webpackMode: "eager", webpackExports: ["useWatchBlocks"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useWatchBlocks.js");
;
import(/* webpackMode: "eager", webpackExports: ["useWatchContractEvent"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useWatchContractEvent.js");
;
import(/* webpackMode: "eager", webpackExports: ["useWatchPendingTransactions"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useWatchPendingTransactions.js");
;
import(/* webpackMode: "eager", webpackExports: ["useWriteContract"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hooks/useWriteContract.js");
;
import(/* webpackMode: "eager", webpackExports: ["Hydrate"] */ "/vercel/path0/node_modules/wagmi/dist/esm/hydrate.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/providers/DatadogInit.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/nextjs/app/styles/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/packages/nextjs/components/ui/sonner.tsx");
